import styled from 'styled-components'

const Badge = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  background: linear-gradient(135deg, rgba(20, 184, 166, 0.85), rgba(16, 185, 129, 0.85));
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 7px;
  z-index: 2;
  white-space: nowrap;
  pointer-events: none;
`

export default function SubTitleBadge({ text }) {
  if (!text) return null
  return <Badge>{text}</Badge>
}
